import gql from 'graphql-tag';

import clientWorkspaceLeadFragment from './client-workspace-lead-fragment';

const findByIdClientWorkspaceLeadQuery = gql`
  ${clientWorkspaceLeadFragment}
  query findByIdClientWorkspaceLeadQuery($_id: MongoID!) {
    findByIdClientWorkspaceLeadQuery(_id: $_id) { ...ClientWorkspaceLeadFragment }
  }
`;
export default findByIdClientWorkspaceLeadQuery;
